import { Box, Button, Container, Paper, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from '../components/Logo';
import { TERMS_CONTENT, TERMS_TITLE } from '../content/termsOfService';
import { colors } from '../theme';

const TermsOfServicePage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: '#f5f7fa',
        py: 4,
        px: 2,
      }}
    >
      <Container maxWidth="md">
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
          <Logo />
          <Button
            variant="outlined"
            onClick={() => navigate(-1)}
            sx={{
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600,
              borderColor: colors.primary.main,
              width: 'fit-content',
              color: colors.primary.main,
              '&:hover': {
                borderColor: colors.primary.dark,
                bgcolor: 'rgba(67, 160, 71, 0.08)',
              },
            }}
          >
            Geri Dön
          </Button>
        </Box>

        <Paper
          elevation={0}
          sx={{
            p: 4,
            borderRadius: 3,
            border: '1px solid #e2e8f0',
            bgcolor: '#fff',
          }}
        >
          <Typography variant="h4" fontWeight={700} sx={{ color: '#263238', mb: 3 }}>
            {TERMS_TITLE}
          </Typography>
          <Box
            component="div"
            sx={{
              '& h2': {
                fontSize: '1.125rem',
                fontWeight: 700,
                color: '#263238',
                mt: 3,
                mb: 1.5,
              },
              '& p': {
                fontSize: '0.9375rem',
                lineHeight: 1.7,
                color: '#455a64',
                mb: 1.5,
              },
              '& strong': { color: '#263238' },
            }}
          >
            {TERMS_CONTENT.split('\n').map((line, i) => {
            if (line.startsWith('## ')) {
              return (
                <Typography key={i} component="h2" variant="subtitle1" sx={{ fontWeight: 700, mt: 3, mb: 1, color: '#263238' }}>
                  {line.replace(/^##\s*/, '')}
                </Typography>
              );
            }
            if (line.startsWith('**') && line.endsWith('**')) {
              return (
                <Typography key={i} component="p" variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
                  {line.replace(/\*\*/g, '')}
                </Typography>
              );
            }
            if (line.trim() === '---') return <hr key={i} style={{ border: 'none', borderTop: '1px solid #e0e0e0', margin: '24px 0' }} />;
            if (line.trim()) {
              return (
                <Typography key={i} component="p" variant="body2" sx={{ mb: 1, lineHeight: 1.7, color: '#455a64' }}>
                  {line}
                </Typography>
              );
            }
            return null;
          })}
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default TermsOfServicePage;
